module.exports = __webpack_public_path__ + "img/homework_scoring.3f183bbb.png";